import React from "react";
var QRCode = require("qrcode.react");

const generateQRCode = (signature: string) => (
  <QRCode
    value={signature}
    size={200}
    bgColor={"#ffffff"}
    fgColor={"#000000"}
    level={"L"}
    includeMargin={false}
    renderAs={"canvas"}
  />
);
export default generateQRCode;
